import { render, staticRenderFns } from "./comp_dpc-SliderPlus2Banners.vue?vue&type=template&id=6c4639d9&scoped=true"
import script from "./comp_dpc-SliderPlus2Banners.vue?vue&type=script&lang=js"
export * from "./comp_dpc-SliderPlus2Banners.vue?vue&type=script&lang=js"
import style0 from "./comp_dpc-SliderPlus2Banners.vue?vue&type=style&index=0&id=6c4639d9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4639d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
